import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";

const selCls = "h-10 w-full rounded-md border bg-transparent px-2 text-sm";

export function HistoryFilters({ f, setF, users, status }) {
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  return (
    <div className="card-surface grid gap-3 p-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="comandas-history-filters">
      <Field label="De"><Input type="date" value={f.start} onChange={set("start")} data-testid="comandas-start" /></Field>
      <Field label="Até"><Input type="date" value={f.end} onChange={set("end")} data-testid="comandas-end" /></Field>
      <Field label="Período pela data de">
        <select value={f.by} onChange={set("by")} className={selCls} data-testid="comandas-date-by">
          <option value="closed">{status === "cancelled" ? "Cancelamento" : "Fechamento"}</option>
          <option value="opened">Abertura</option>
        </select>
      </Field>
      <Field label="Usuário">
        <select value={f.user_name} onChange={set("user_name")} className={selCls} data-testid="comandas-user">
          <option value="">Todos os usuários</option>{users.map((u) => <option key={u} value={u}>{u}</option>)}
        </select>
      </Field>
    </div>
  );
}
